import { NetworkIcon } from 'elements/NetworkIcon';
import { NETWORK_IDS } from 'lib/constants';
import { omitBy } from 'lodash';
import { isProd } from 'lib/helpers';
import { SignInOptions } from './types';

interface Props {
  returnTo?: string;
  errorTo?: string;
  text?: string;
}

export const onClickInstagramSignIn = (options: SignInOptions) => {
  const useInstagramAuth = !isProd();
  const baseUrl = useInstagramAuth
    ? '/api/auth/instagram'
    : '/api/auth/facebook/signup';

  const allParams = {
    next: options.returnTo || '/',
    username: options.username,
    errorTo: options.errorTo,
    network: useInstagramAuth ? undefined : NETWORK_IDS.instagram.toString(),
  };
  const params = omitBy(allParams, (v) => !v) as Record<string, string>;
  const authUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;

  window.location.href = authUrl;
};

export const InstagramSignIn = ({ returnTo, text, errorTo }: Props) => {
  const onClick = () => onClickInstagramSignIn({
    returnTo,
    errorTo,
  });

  return (
    <button
      type="button"
      className="rounded-lg bg-black hover:bg-opacity-90 font-bold text-white text-xl w-full max-w-xs py-2"
      onClick={onClick}
    >
      <NetworkIcon
        style={{
          color: 'white',
          marginRight: '8px',
          verticalAlign: 'middle',
        }}
        network={NETWORK_IDS.instagram}
      />
      {text || 'Sign in with Instagram'}
    </button>
  );
};
